import type { PositionIntent, SendCartUserData } from '~/features/cart/state-machine/types';
import type { IAvailabilityOptionDtoData } from '~/dtos/ProdegaApiWebshop-api-typings-generated';

export type UserOptionSelectedEvent = {
  type: 'userOptionSelected';
  selectedUserDialogOption: IAvailabilityOptionDtoData[];
};

export const CartEventTypes = {} as
  | { type: 'login' }
  | { type: 'logout' }
  | { type: 'addPositionIntent'; value: PositionIntent }
  | { type: 'removePositionIntent'; value: PositionIntent }
  | { type: 'cancelCart' }
  | { type: 'sendCart'; sendCartParams: SendCartUserData }
  | { type: 'changeDeliveryDateOfCart' }
  | { type: 'abortUserInputForCart' }
  | { type: 'reloadShoppingCart' }
  | { type: 'refreshShoppingCart' }
  | { type: 'chooseDeliveryDate'; desiredDeliveryDate: string }
  | { type: 'acknowledgeBlockedPositionsDialog' }
  | { type: 'resetBlockedPositionsAcknowledge' }
  | UserOptionSelectedEvent;
